import React, { Fragment } from 'react';
import { useInView } from 'react-intersection-observer';
import { Box, Flex } from 'roo-ui/components';
import PageBlock from 'components/PageBlock';
import PointsPayCheckbox from 'components/PointsPayCheckbox';
import { PAY_WITH_OPTIONS } from 'lib/enums/payment';
import theme from 'lib/theme';
import PayWith from 'pages/Property/PayWith';
import PayWithToggleMessage from 'components/PayWithToggleMessage';

const PaymentOptions = () => {
  const [ref, inView] = useInView({
    rootMargin: '-10px 0px 500px 0px',
  });

  const containerShadow = inView ? 0 : theme.shadows.hard;
  const size = inView ? 'base' : 'sm';
  const zIndex = inView ? 1 : theme.zIndices.stickyPaymentOptions;

  return (
    <Fragment>
      <div id="main-content"></div>
      <Box pt={8} ref={ref} />
      <PageBlock
        backgroundColor="greys.porcelain"
        boxShadow={[0, containerShadow]}
        position={['none', 'sticky']}
        printable={false}
        py={2}
        top={57}
        zIndex={zIndex}
      >
        <Flex flexDirection={['column', 'row']} justifyContent="space-between">
          <Flex alignItems={['stretch', 'center']} flexDirection={['column', 'row']}>
            <PayWith options={PAY_WITH_OPTIONS} size={size} />
            <PayWithToggleMessage pointingDirection="left" ml={4} display={['none', 'block']} />
          </Flex>

          <PointsPayCheckbox mt={[4, 0]} showPointsDescription={inView} size={size} textAlign={['center', 'right']} />
        </Flex>
      </PageBlock>
      <PageBlock pt={6}>
        <Box borderBottom={1} borderColor="greys.alto" />
      </PageBlock>
    </Fragment>
  );
};

export default PaymentOptions;
